import { render, staticRenderFns } from "./AppointDetail.vue?vue&type=template&id=f6c33870&scoped=true&"
import script from "./AppointDetail.vue?vue&type=script&lang=js&"
export * from "./AppointDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointDetail.vue?vue&type=style&index=0&id=f6c33870&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c33870",
  null
  
)

export default component.exports